import { GetterTree, MutationTree, ActionTree, ActionContext } from 'vuex';
import type { IInteractiveAccessObjectsInfo } from '@/@types/api/interactiveAccessObjects';

import {
  getList as apiGetList,
  getWebCams as apiGetWebCams,
  getStreamLink as apiGetStreamLink,
  getScreenshot as apiGetScreenshot,
  activate as apiActivate,
} from '@/api/interactiveAccessObjects';

interface IState {
  interactiveAccessObjects: IInteractiveAccessObjectsInfo[] | [];
}

export default {
  state: (): IState => ({
    interactiveAccessObjects: [],
  }),

  mutations: <MutationTree<IState>>{
    SET_METERS(state, data: IInteractiveAccessObjectsInfo[]) {
      state.interactiveAccessObjects = data;
    },
  },

  actions: <ActionTree<IState, any>>{
    getList: async (_, accountId: number) => {
      try {
        const result = await apiGetList(accountId);

        return result;
      } catch (error) {
        console.log(error);
      }
    },

    getWebCams: async (_, params) => {
      try {
        const result = await apiGetWebCams(params);

        return result;
      } catch (error) {
        console.log(error);
      }
    },

    getStreamLink: async (_, params) => {
      try {
        const result = await apiGetStreamLink(params);

        return result;
      } catch (error) {
        console.log(error);
      }
    },

    getScreenshot: async (_, params) => {
      try {
        const result = await apiGetScreenshot(params);

        return result;
      } catch (error) {
        console.log(error);
      }
    },

    activate: async (_, params) => {
      try {
        const result = await apiActivate(params);

        return result;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
